import { template as template_080e0a6eee4245d3a9e3d7bb0bc344d8 } from "@ember/template-compiler";
import BsForm from 'eflex/components/bs-form';
export default template_080e0a6eee4245d3a9e3d7bb0bc344d8(`
<BsForm @model={{this}} @readonly={{true}} as |form|>
  <form.element
    class="jem-model-display mb-0"
    @controlType="text"
    @size="lg"
    @value={{if @productionScheduleEnabled @productionScheduleModelCode @buildStatusModelCode}}
  as |el|>
    <el.control
      class="fw-semibold"
      title={{el.value}}
    />
  </form.element>
</BsForm>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
